import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

if (!supabaseUrl || !supabaseAnonKey || supabaseUrl === '' || supabaseAnonKey === '') {
  throw new Error('Missing or empty Supabase environment variables. Please check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file');
}

// Validate URL format
try {
  new URL(supabaseUrl);
} catch (error) {
  throw new Error(`Invalid VITE_SUPABASE_URL format: ${supabaseUrl}`);
}

// Ensure consistent storage keys across the application
const STORAGE_KEY = 'supabase.auth.token';
const REFRESH_TOKEN_KEY = 'supabase.auth.refreshToken';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: STORAGE_KEY,
    // Force sign out on session expiry
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
});

// Export storage keys for consistent usage
export const SUPABASE_STORAGE_KEYS = {
  AUTH_TOKEN: STORAGE_KEY,
  REFRESH_TOKEN: REFRESH_TOKEN_KEY,
};